import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseNabidkySmlouvySearch } from '@/lib/list-search';

const SmlouvaDetail = lazy(() =>
  import('@/modules/vozidla/SmlouvaDetail').then((m) => ({ default: m.SmlouvaDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/smlouvy/$id',
  component: () => (
    <Suspense fallback={null}>
      <SmlouvaDetail />
    </Suspense>
  ),
  // Same shape as the list route so the detail's master rail shows the same
  // cohort (name + number filters) the user was browsing.
  validateSearch: parseNabidkySmlouvySearch,
});
